import React, { useEffect, useMemo } from 'react'
import styles from './styles.module.css'
import Button from '../../components/Button'
import { IoIosAdd } from 'react-icons/io'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import Modal from './Modal'
import Table from '../../components/Table'
import { BiTrash } from 'react-icons/bi'
import Confirmation from '../../components/Confirmation/Confirmation'
import { deleteTypicalComment, getTypicalComment } from '../../actions/typicalComment'
export default function TypicalComment() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { typicalCommentList } = useSelector(state => state.typical_comment)

  const [selectedItem, setSelectedItem] = useState(null)
  const [confirmation, setConfirmation] = useState(false);
  const [sortAsc, setSortAsc] = useState(true)

  useEffect(() => {
    dispatch(getTypicalComment())
  }, [selectedItem])

  const sortedList = useMemo(() => {
    if (!typicalCommentList) return []
    return [...typicalCommentList].sort((a, b) => sortAsc
      ? a.commenttext?.localeCompare(b.commenttext, 'ru')
      : b.commenttext?.localeCompare(a.commenttext, 'ru'))
  }, [typicalCommentList, sortAsc])

  const openModal = (data) => () => {
    setSelectedItem(data || {})
  }

  const closeModal = () => setSelectedItem(null)

  const goHome = () => navigate('/')

  const acceptConfirmation = () => {
    closeModal();
    dispatch(deleteTypicalComment(confirmation.id));
    setConfirmation(false);
  };
  const rejectConfirmation = () => {
    setConfirmation(false);
  };

  const renderLi = (data) => {
    const { commentid, commenttext } = data
    return (
      <tr >
        <td onClick={openModal(data)}>{commenttext}</td>
        <td><i className={styles.trash} onClick={() => setConfirmation({ id: commentid, name: commenttext })}><BiTrash /></i></td>
      </tr>
    )
  }

  return (
    <div className={styles.wrapper} style={{ width: '700px', margin: '0 auto' }}>
      {confirmation && (
        <Confirmation
          top="30px"
          left="40px"
          title={`Вы уверены, что хотите удалить ${confirmation.name}?`}
          acceptConfirmation={() => acceptConfirmation(confirmation?.name)}
          rejectConfirmation={rejectConfirmation}
        />
      )}
      {selectedItem &&
        <Modal
          closeModal={closeModal}
          data={selectedItem}
          height={'430px'}
          // addMode={(!selectedItem?.name && selectedItem !== null)}
          addMode={!selectedItem.commenttext}
        />
      }
      <h1>Типовые комментарии к оценкам</h1>
      {!!typicalCommentList?.length ?
        <Table className={styles.tableDis}>
          <thead>
            <tr>
              <th onClick={() => setSortAsc(v => !v)} style={{ cursor: 'pointer' }}>Название</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {sortedList.map(renderLi)}
          </tbody>
        </Table>
        :
        <div className={styles.noData}>Нет данных</div>
      }
      <div style={{ display: 'flex', flexDirection: "row" }}>
        <Button
          style={{ padding: '.5rem 1.5rem', margin: '12px' }}
          onClick={openModal()}
        >
          <IoIosAdd size={30} />
          Добавить
        </Button>
      </div>
    </div>
  )
}
